/**
 * View image block.
 * @module components/manage/Blocks/Hero/View
 */

import React from 'react';
import PropTypes from 'prop-types';
import { flattenToAppURL } from '@plone/volto/helpers';
import { Image } from '@plone/volto/components';
import StoresButtons from '@package/components/Blocks/HeroImageLeft/StoresButtons';

/**
 * View image block class.
 * @class View
 * @extends Component
 */
const View = ({ data }) => (
  <div className="block hero">
    <div className="block-inner-wrapper">
      {data.url && (
        <Image
          src={`${flattenToAppURL(data.url)}/@@images/image`}
          alt={data.alt}
          className="hero-image"
          loading="lazy"
        />
      )}
      <div className="hero-body">
        {data.title && <h1>{data.title}</h1>}
        {data.description && <p>{data.description}</p>}
        <StoresButtons data={data} />
      </div>
    </div>
  </div>
);

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
